import React from 'react';
import { useTranslation } from 'react-i18next';
import DescriptionListItem from 'components/v2/DescriptionListItem';
import Table from 'components/v2/Table';
import Button from 'components/v2/buttons/Button';
import CargomaticModal from 'components/v2/modal';
function AccessorialDetailsBody(accessorial) {
    var _a;
    const { t } = useTranslation();
    const columns = [
        {
            field: 'value',
            label: t('REQUIRED_DOCUMENTS'),
            render: (value, row) => {
                return t(value === null || value === void 0 ? void 0 : value.toUpperCase());
            },
        },
    ];
    if (!accessorial) {
        return null;
    }
    return (React.createElement("div", null,
        React.createElement("div", { className: "grid grid-cols-2 gap-4 mb-4" },
            React.createElement("div", { className: "mb-4" },
                React.createElement(DescriptionListItem, { labelClassName: "block text-sm font-medium text-gray-700 font-semibold", label: t('ACCESSORIAL') }, t((_a = accessorial === null || accessorial === void 0 ? void 0 : accessorial.accessorial) === null || _a === void 0 ? void 0 : _a.toUpperCase()))),
            React.createElement("div", { className: "mb-4" },
                React.createElement(DescriptionListItem, { labelClassName: "block text-sm font-medium text-gray-700 font-semibold", label: t('CUSTOMER_APPROVAL_REQUIRED_QUESTION') },
                    accessorial.customer_approval_required && React.createElement("span", null, t('YES')),
                    !accessorial.customer_approval_required && React.createElement("span", null, t('NO')))),
            React.createElement("div", { className: "col-span-full" },
                React.createElement(Table, { columns: columns, data: accessorial === null || accessorial === void 0 ? void 0 : accessorial.rules, headers: columns, className: "overflow-hidden shadow ring-1 ring-gray-200 sm:rounded-lg", trClassName: "border rounded-sm" })))));
}
function AccessorialDetailsFooter(onHide) {
    const { t } = useTranslation();
    return (React.createElement("div", null,
        React.createElement(Button, { type: "button", onClick: onHide }, t('CLOSE'))));
}
export default function AccessorialDetails({ accessorial, onHide, viewMode }) {
    const { t } = useTranslation();
    return (React.createElement(CargomaticModal, { title: t('VIEW_ACCESSORIAL'), titleClassNames: "text-lg font-medium leading-6 text-gray-700", show: !!accessorial && viewMode, onHide: onHide, body: AccessorialDetailsBody(accessorial), footer: AccessorialDetailsFooter(onHide) }));
}
